import { useEffect, useState } from "react";
import { requiresDesktopForPlayer } from "../lib/playerDevice";

export const useRequiresDesktop = () => {
  const [blocked, setBlocked] = useState(requiresDesktopForPlayer);

  useEffect(() => {
    const check = () => setBlocked(requiresDesktopForPlayer());
    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);

  return blocked;
};
